<template>
  <div id="header">
    <div id="banner" v-if="$store.state.menuIndex == 0 && $route.name !== 'indexDetail'">
      <div class="fixed">
        <div class="wrap">
          <NavCom />
          <div class="k-slick">
            <div class="btn btn_left"></div>
            <ul>
              <li v-for="(item, index) in deviceList" :key="index">
                <img :src="item.imgUrl" />
              </li>
            </ul>
            <div class="btn btn_right"></div>
          </div>
        </div>
      </div>
      <swiper class="swiper" :options="swiperOption">
        <swiper-slide v-for="(item, index) in deviceList" :key="index">
          <div class="swiper-zoom-container banner-slide">
            <div
              class="swiper-img"
              :style="{
                'background-image': 'url(' + item.imgUrl + ')',
              }"
            ></div>
            <div v-if="item.displayTitle || item.displaySubTitle2 || item.displayDescription" class="banner-copy">
              <p v-if="item.displaySubTitle2" class="banner-copy__subtitle">{{ item.displaySubTitle2 }}</p>
              <h1 v-if="item.displayDescription" class="banner-copy__description">{{ item.displayDescription }}</h1>
              <h2 v-if="item.displayTitle" class="banner-copy__title">{{ item.displayTitle }}</h2>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
      </swiper>
    </div>

    <div class="dealer" v-if="$store.state.menuIndex == 1">
      <div id="banner-dealer" @click="openJoin">
        <p id='banner-dealer_bigTitle'>{{ $t("header.立即與OTTBUS合作吧！") }}</p>
        <p id='banner-dealer_smallTitle'>{{ $t("header.加入我們，開啓賺錢的旅程！") }}</p>
        <el-button  plain round id="banner-dealer_button">{{ $t("header.馬上開始") }}</el-button>
      </div>
      <div>
        
      </div>
      <div class="fixed">
        <div class="wrap">
          <NavCom />
        </div>
      </div>
    </div>

    <div id="banner-help" v-if="$store.state.menuIndex == 2 && $route.name == 'Help'">
      <div class="fixed">
        <div class="wrap">
          <NavCom />
        </div>
      </div>
      <div class="title">{{ $t("header.helpTitle") }}</div>
      <div class="help-search-box">
        <i class="el-icon-search"></i>
        <input
          v-model="helpSearchKeyword"
          type="text"
          :placeholder="$t('helpPage.searchPlaceholder')"
          @keyup.enter="handleHelpSearch"
        />
      </div>
    </div>

    <div id="banner-user" v-if="$store.state.menuIndex > 2">
      <div class="fixed">
        <div class="wrap">
          <NavCom />
        </div>
      </div>
      <div class="banner-title">
        <span v-if="$store.state.menuIndex == 3">{{ $t("header.subscriptionTitle") }}</span>
        <span v-else-if="$store.state.menuIndex == 4">{{ $t("header.userCenterTitle") }}</span>
        <span v-else-if="$store.state.menuIndex == 5">{{ $t("header.myPromotionTitle") }}</span>
        <span v-else-if="$store.state.menuIndex == 6">{{ $t("header.orderTitle") }}</span>
        <span v-else-if="$store.state.menuIndex == 7">{{ $t("header.myWalletTitle") }}</span>
        <span v-else-if="$store.state.menuIndex == 8">{{ $t("header.myCouponsTitle") }}</span>
        <span v-else-if="$store.state.menuIndex == 9">{{ $t("header.couponCenterTitle") }}</span>
        <span v-else-if="$store.state.menuIndex == 10">{{ $t("header.registerCouponTitle") }}</span>
        <span v-else>{{ $t("header.userCenterTitle") }}</span>
      </div>
    </div>

    <div
      id="banner-help-detail"
      v-if="$store.state.menuIndex == 2 && ($route.name == 'HelpDetail' || $route.name == 'Login' || $route.name == 'Content')"
    >
      <div class="fixed">
        <div class="wrap">
          <NavCom />
        </div>
      </div>
    </div>

    <div id="banner-detail" v-if="$store.state.menuIndex == 0 && $route.name == 'indexDetail'">
      <div class="fixed">
        <div class="wrap">
          <NavCom />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavCom from "./Nav.vue";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { getArticleLlist } from "@/api/article.js";
import { getToken } from "@/utils/auth";
import { normalizeBannerList } from "@/utils/banner";

export default {
  name: "HeaderCom",
  components: {
    NavCom,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        zoom: true,
        loop: true,
        navigation: {
          nextEl: ".btn_right",
          prevEl: ".btn_left",
        },
      },
      rawDeviceList: [],
      helpSearchKeyword: "",
    };
  },
  computed: {
    deviceList() {
      return normalizeBannerList(this.rawDeviceList, this.$i18n.locale);
    },
  },
  created() {
    this.getBanner();
  },
  methods: {
    async getBanner() {
      try {
        const res = await getArticleLlist({
          code: "banner",
        });
        this.rawDeviceList = Array.isArray(res.data) ? res.data : [];
      } catch (error) {
        this.rawDeviceList = [];
      }
    },
    openJoin() {
      if (!getToken()) {
        this.$router.push({
          path: "/login",
          query: { redirect: this.$route.fullPath },
        });
        return;
      }
      this.$bus.$emit("openJoin");
    },
    handleHelpSearch() {
      const keyword = this.helpSearchKeyword.trim();
      if (keyword) {
        this.$bus.$emit("helpSearch", keyword);
      }
    },
  },
};
</script>

<style lang="scss" scoped>

#header {
  .fixed {
    -webkit-backdrop-filter: blur(0.520833vw);
    backdrop-filter: blur(0.520833vw);
    background-color: #0000001a;
    padding: 10px 0;
    width: 100%;
    position: fixed;
    z-index: 999;
    left: 0;
    top: 0;
  }

  #banner {
    height: 430px;
    position: relative;

    .swiper {
      position: absolute;
      //border: 1px solid transparent;
      inset: 0;
      z-index: 0;
    }

    .banner-slide {
      position: relative;
      height: 430px;
      overflow: hidden;
    }

    .swiper-img {
      height: 430px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      width: 100%;
    }

    .banner-copy {
      position: absolute;
      left: 120px;
      bottom: 180px;
      max-width: 520px;
      color: #fff;
      text-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
      z-index: 2;
    }

    .banner-copy__title {
      margin: 0;
      width: 900px;
      //font-size: 60px;
      line-height: 1.15;
      font-weight: 700;
      font-size: 28px;
      color: #D3D4D6;
      
      //letter-spacing: 0.02em;
    }

    .banner-copy__subtitle {
      margin: 8px 0 0;
      font-size: 36px;
      line-height: 1.3;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.85);
    }

    .banner-copy__description {
      margin: 14px 0 0;
      font-size: 60px;
      //line-height: 1.75;
      width: 900px;
      //font-weight: 600;
      color: rgba(255, 255, 255, 0.92);
    }

    .wrap {
      position: relative;
      height: 100%;

      .k-slick {
        position: absolute;
        right: 0;
        bottom: 120px;

        .btn {
          display: inline-block;
          width: 36px;
          height: 36px;
          position: absolute;
          cursor: pointer;

          &.btn_left {
            background: url(../assets/btn_left.png) no-repeat center;
            background-size: cover;
            margin-top: 30px;
            margin-left: -8px;
          }

          &.btn_right {
            background: url(../assets/btn_right.png) no-repeat center;
            background-size: cover;
            right: 0;
            bottom: 0;
            margin-bottom: 30px;
            margin-right: -8px;
          }
        }

        ul {
          overflow: hidden;

          li {
            float: left;
            border: 5px solid transparent;
            margin: 0 5px;

            &:hover {
              cursor: pointer;
            }

            img {
              width: 146px;
              height: 86px;
              border-radius: 10px;
            }

            &.active {
              border: 5px solid white;
              border-radius: 20px;
              overflow: hidden;
            }

            &.user {
              .user_dropdown {
                vertical-align: middle;
              }
            }
          }
        }
      }
    }
  }

  .dealer {
    display: flex;
    justify-content: center;
    width: 100%;

    .po {
      position: absolute;
      top: 0;
    }
  }

  #banner-dealer {
    height: 430px;
    position: relative;
    flex: 1;
    background: url(../assets/banner_help_dark.png) no-repeat center;
    background-size: cover;
    text-align: center;
    #banner-dealer_bigTitle{ 
      margin: 80px auto;
      font-size:73px;
      color:#fff;
      margin-bottom:0;
    }
    #banner-dealer_smallTitle {
      margin: 0px auto;
      font-size:40px;
      color:#fff;
      margin-bottom:0;
    }
   #banner-dealer_button{
      font-size:20px;
      margin-top:20px;
      
    }
  }  
  #banner-help {
    height: 350px;
    background: url(../assets/banner_help_dark.png) no-repeat center;
    background-size: cover;

    .title {
      color: #ffffff;
      font-size: 45px;
      text-align: center;
      padding-top: 130px;
      line-height: 1.1;
      padding-bottom: 20px;
    }

    .help-search-box {
      width: 600px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      height: 50px;
      background: #fff;
      border-radius: 25px;
      padding: 0 25px;
      box-shadow: 0 4px 20px rgba(29, 64, 255, 0.15);

      i {
        font-size: 18px;
        color: #1d40ff;
        margin-right: 15px;
      }

      input {
        flex: 1;
        border: none;
        outline: none;
        font-size: 15px;
        background: transparent;

        &::placeholder {
          color: #aaa;
        }
      }
    }
  }

  #banner-help-detail {
    height: 200px;
    background: url(../assets/banner_help_dark.png) no-repeat center;
    background-size: cover;
  }

  #banner-detail {
    height: 66px;
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  }

  #banner-user {
    height: 280px;
    background: url(../assets/banner_help_dark.png) no-repeat center;
    background-size: cover;
    position: relative;

    .banner-title {
      color: #ffffff;
      font-size: 38px;
      font-weight: bold;
      text-align: center;
      padding-top: 140px;
      line-height: 1.2;
      text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    }
  }
}
</style>
